module.exports = __webpack_public_path__ + "img/icon.70914409.svg";